// @flow
import { handleTagEvent }from 'utils/tagManagerUtils';

export const tagsUtils = (_articleContent: HTMLElement) => {
  let _links;
  let _embedTweet;
  let _embedFacebook;
  let _embedInstagram;
  let _memberModule;
  let _matchModule;
  let _hubModule;
  let _eventAll;
  let _eventModule;
  let _competitionModule;
  let _clubModule;
  let _similarArticleModule;

  if (_articleContent) {
    const downloads = Array.from(_articleContent.getElementsByClassName('card--download'));
    downloads.forEach((download) => {
      _links = Array.from(download.getElementsByTagName('a'));
      addNewTagsTypeEvents(_links, 'module telechargement', 'clic telechargement', window.location.pathname, true);
    });

    _embedTweet = Array.from(_articleContent.getElementsByClassName('is-provider-twitter'));
    addNewTagsTypeEvents(_embedTweet, 'module social', 'clic publication twitter', window.location.pathname);

    _embedFacebook = Array.from(_articleContent.getElementsByClassName('is-provider-facebook'));
    addNewTagsTypeEvents(_embedFacebook, 'module social', 'clic publication facebook', window.location.pathname);

    _embedInstagram = Array.from(_articleContent.getElementsByClassName('is-provider-instagram'));
    addNewTagsTypeEvents(_embedInstagram, 'module social', 'clic publication instagram', window.location.pathname);

    const memberCard = Array.from(_articleContent.getElementsByClassName('wp-block-ffrblocks-liste-personnes'));
    memberCard.forEach((download) => {
      _memberModule = Array.from(download.getElementsByTagName('a'));
      addNewTagsTypeEvents(_memberModule, 'module membre', 'clic mail', window.location.pathname);
    });

    _matchModule = Array.from(_articleContent.getElementsByClassName('card--game'));
    addNewTagsTypeEvents(_matchModule, 'module match', 'clic lien sortant', window.location.pathname);

    _hubModule = Array.from(_articleContent.getElementsByClassName('card--hub'));
    addNewTagsTypeEvents(_hubModule, 'module hub', 'clic gerer mon club', window.location.pathname);

    const blockEvent = Array.from(_articleContent.getElementsByClassName('event'));
    blockEvent.forEach((blockEvent) => {
      _eventAll = Array.from(blockEvent.getElementsByClassName('link-chevron'));
      addNewTagsTypeEvents(_eventAll, 'module evenement', 'clic decouvrir les evenements', window.location.pathname);
      _eventModule = Array.from(blockEvent.getElementsByClassName('event__title'));
      _eventModule.forEach((element) => {
        const link = element.getElementsByTagName('a');
        element.addEventListener(
          'click',
          handleTagEvent('module evenement', `clic ${link[0].innerHTML}`, window.location.pathname)
        );
      });
    });

    const relatedCompetitions = Array.from(_articleContent.getElementsByClassName('block-related-competitions'));
    relatedCompetitions.forEach((relatedCompetition) => {
      _competitionModule = Array.from(relatedCompetition.getElementsByClassName('link-competition--card'));
      _competitionModule.forEach((element) => {
        const title = element.getElementsByClassName('link-competition__title');
        element.addEventListener(
          'click',
          handleTagEvent('module competitions associees', `clic ${title[0].innerHTML}`, window.location.pathname)
        );
      });
    });

    _clubModule = Array.from(_articleContent.getElementsByClassName('card--club'));
    _clubModule.forEach((element) => {
      const title = element.getElementsByClassName('card__title');
      element.addEventListener(
        'click',
        handleTagEvent('module club', `clic ${title[0].innerHTML}`, window.location.pathname)
      );
    });

    _similarArticleModule = Array.from(_articleContent.getElementsByClassName('news--row--gtm'));
    _similarArticleModule.forEach((element) => {
      const title = element.getElementsByClassName('news__title');
      element.addEventListener('click', handleTagEvent('actualite', 'clic actualites similaires', title[0].innerHTML));
    });
  }

  return {
    removeTagsEvents: () => {
      if (_links) {
        _links.forEach( element => {
          /// $FlowFixMe
          const url: string = element.href !== '' ? element.href : '';
          const labelEvent = url !== '' ? `${window.location.pathname} ${url}` : window.location.pathname;
          element.removeEventListener(
            'click',
            handleTagEvent('module telechargement', 'clic telechargement', labelEvent)
          );
        });
      }
      if (_embedTweet) {
        _embedTweet.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module social', 'clic publication twitter', window.location.pathname)
          );
        });
      }
      if (_embedFacebook) {
        _embedFacebook.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module social', 'clic publication facebook', window.location.pathname)
          );
        });
      }
      if (_embedInstagram) {
        _embedInstagram.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module social', 'clic publication instagram', window.location.pathname)
          );
        });
      }
      if (_memberModule) {
        _memberModule.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module membre', 'clic mail', window.location.pathname)
          );
        });
      }
      if (_matchModule) {
        _matchModule.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module match', 'clic lien sortant', window.location.pathname)
          );
        });
      }
      if (_hubModule) {
        _hubModule.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module hub', 'clic gerer mon club', window.location.pathname)
          );
        });
      }
      if (_eventAll) {
        _eventAll.forEach( element => {
          element.removeEventListener(
            'click',
            handleTagEvent('module evenement', 'clic decouvrir les evenements', window.location.pathname)
          );
        });
      }
      if (_eventModule) {
        _eventModule.forEach( element => {
          const link = element.getElementsByTagName('a');
          element.removeEventListener(
            'click',
            handleTagEvent('module evenement', `clic ${link[0].innerHTML}`, window.location.pathname)
          );
        });
      }
      if (_competitionModule) {
        _competitionModule.forEach( element => {
          const title = element.getElementsByClassName('link-competition__title');
          element.removeEventListener(
            'click',
            handleTagEvent('module competitions associees', `clic ${title[0].innerHTML}`, window.location.pathname)
          );
        });
      }
      if (_clubModule) {
        _clubModule.forEach( element => {
          const title = element.getElementsByClassName('card__title');
          element.removeEventListener(
            'click',
            handleTagEvent('module club', `clic ${title[0].innerHTML}`, window.location.pathname)
          );
        });
      }
      if (_similarArticleModule) {
        _similarArticleModule.forEach( element => {
          const title = element.getElementsByClassName('news__title');
          element.removeEventListener(
            'click',
            handleTagEvent('actualite', 'clic actualites similaires', title[0].innerHTML)
          );
        });
      }
    }
  };

};

function addNewTagsTypeEvents(
  elements: Array<HTMLElement>,
  eventCategory: string,
  eventAction: string,
  eventLabel: string,
  isDownload?: boolean = false
) {
  elements.forEach((element) => {
    let labelEvent = eventLabel;
    if (isDownload) {
      // $FlowFixMe
      let url: string = isDownload && element.href !== '' ? element.href : '';

      if (url === '') {
          // $FlowFixMe
          url = element.dataset && element.dataset.url !== '' ? element.dataset.url : '';
      }

      labelEvent = url !== '' ? `${eventLabel} ${url}` : `${eventLabel} `;
    }

    element.addEventListener('click', handleTagEvent(eventCategory, eventAction, labelEvent));
  });
}
